import {Injectable} from '@angular/core';
import {ApiConfig} from '@api/configs';
import {HttpClient} from '@angular/common/http';
import {ApiArticlesGetRequest, ApiArticlesGetRequestParams, ApiArticlesGetResponse} from '@api/articles';
import {Observable} from 'rxjs';
import {EnvironmentService} from '@iw-shop/core//services/environment.service';
import {NumberFormat} from '@iw-shop/core//functions/number-format';
import {AppState} from '@store/state/app.state';
import {Store} from '@ngrx/store';
import {take} from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class ArticleService {
  availabilities: ApiConfig['articleAvailabilities'] = [];


  constructor(private http: HttpClient, private environmentService: EnvironmentService, private store: Store<AppState>) {

  }

  getCurrency(): 'EUR' | 'CHF'{
    let currency: 'EUR' | 'CHF' = 'EUR';
    this.store.select(state => state.config)
      .pipe(
        take(1)
      )
      .subscribe(
        r => {
          if (r.currency) {
            currency = r.currency;
          }
        }
      );
    return currency;
  }

  getBatch(requests: ApiArticlesGetRequest[]): Observable<ApiArticlesGetResponse[]> {
    return this.http.post<ApiArticlesGetResponse[]>(this.environmentService.environment.urlApi, JSON.stringify(requests));
  }

  get(params: ApiArticlesGetRequestParams): Observable<ApiArticlesGetResponse> {
    const body: ApiArticlesGetRequest = {id: 'getArticles', command: 'articles/get', params};
    return this.http.post<ApiArticlesGetResponse>(this.environmentService.environment.urlApi, JSON.stringify(body));
  }

  setAvailabilities(availabilities: ApiConfig['articleAvailabilities']) {
    this.availabilities = availabilities;
  }

  getAvailability(inventory: number, availability?: string): string {

    if (availability &&
      availability.length > 0) {
      return availability;
    }

    let availabilities: ApiConfig['articleAvailabilities'] = this.availabilities.filter(
      availability =>
        (
          (
            availability.fromInventory === null ||
            (
              availability.fromInventory !== undefined &&
              inventory >= availability.fromInventory
            )
          )
          &&
          (
            availability.toInventory === null ||
            (
              availability.toInventory !== undefined &&
              inventory <= availability.toInventory
            )
          )
        )
    );


    if (availabilities[0]) {
      return availabilities[0].availability;
    }
    return '';
  }

  getAvailabilityColor(inventory: number, availability?: string): string {
    let availabilities: ApiConfig['articleAvailabilities'];
    if (availability &&
      availability.length > 0) {
      availabilities = this.availabilities.filter(
        availabilityC => availabilityC.availability == availability
      );
      if (availabilities[0]) {
        return availabilities[0].color;
      }
    }

    availabilities = this.availabilities.filter(
      availability =>
        (
          (
            availability.fromInventory === null ||
            (
              availability.fromInventory !== undefined &&
              inventory >= availability.fromInventory
            )
          )
          &&
          (
            availability.toInventory === null ||
            (
              availability.toInventory !== undefined &&
              inventory <= availability.toInventory
            )
          )
        )
    );
    if (availabilities[0]) {
      return availabilities[0].color;
    }
    return 'red';
  }

  getBasicPrice(quantity: number, unit: number, netPrice: number, taxRate: number, priceMode: 'gross' | 'net') {
    let basicPrice: any = (netPrice / (quantity * unit)).toFixed(3);
    basicPrice = parseFloat(basicPrice);

    if (priceMode == 'net') {
      return NumberFormat(basicPrice, this.getCurrency());

    } else {
      return NumberFormat(((basicPrice) / 100 * (100 + taxRate)), this.getCurrency());
    }
  }

  getUnitPrice(quantity: number, netPrice: number, taxRate: number, priceMode: 'gross' | 'net') {
    let unitPrice: any = (netPrice / quantity).toFixed(3);
    unitPrice = parseFloat(unitPrice);
    if (priceMode == 'net') {
      return NumberFormat(unitPrice, this.getCurrency());
    } else {
      return NumberFormat((unitPrice / 100) * (100 + taxRate), this.getCurrency());
    }
  }


  getPrice(netPrice: number, taxRate: number, priceMode: 'gross' | 'net'): string {
    if (priceMode == 'net') {
      return NumberFormat(netPrice, this.getCurrency());

    } else {
      return NumberFormat((netPrice / 100 * (100 + taxRate)), this.getCurrency());
    }
  }
}
